import { useState } from 'react'

import { MissingAgreementDataTableQueryVariables } from 'generated/resources/datatable.graphql'
import moment from 'moment'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'
import { apiClient } from 'modules/core/lib/mobx-rest'

import { incompleteContractsData } from '../ImcompleteContracts'

export const useMissingAgreementDataExport = (
  variables: MissingAgreementDataTableQueryVariables
) => {
  const [isExporting, setIsExporting] = useState(false)
  const onExport = (onSuccess: () => void) => {
    if (isExporting) return
    const date = new Date()
    const formattedDate = moment(date).format('YYYY-MM-DD-HH-mm-ss')

    const fileName = `incomplete-gross-salaries-${formattedDate}`

    const action = async () => {
      try {
        setIsExporting(true)
        const { projections, query } = incompleteContractsData()
        await apiClient().post('/data_table/exports', {
          query: query.loc?.source.body,
          fileName,
          variables,
          projections,
          fileFormat: 'xlsx',
        })
        setIsExporting(false)
        onSuccess()
      } catch (error) {
        setIsExporting(false)
        throw error
      }
    }

    asyncAction(action, {
      successMessage: i18n.t('data_table.export.success'),
    })
  }

  const handleExport = (onSuccess: () => void) => {
    onExport(onSuccess)

    track(trackingEvents.accounting.newFinancialWorkspace.grossSalaryMissingData.export)
  }

  return {
    onExport: handleExport,
    isExporting,
  }
}
